var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1171275858(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#C5DA70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.5V23L25.75 25.75M31.9375 23C31.9375 27.9362 27.9362 31.9375 23 31.9375C18.0638 31.9375 14.0625 27.9362 14.0625 23C14.0625 18.0638 18.0638 14.0625 23 14.0625C27.9362 14.0625 31.9375 18.0638 31.9375 23Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171275858);
export default __webpack_public_path__ + "static/media/Frame 1171275858.5088b5346760ad4db93d53a824b9e2d7.svg";
export { ForwardRef as ReactComponent };